import ApproveClaimDialogContainer from "./approveClaimDialog.container";

export default ApproveClaimDialogContainer;
